import apiClient from "./api";

export interface CustomerDisplayPoster {
  image: string;
  caption: string;
  eyebrow?: string;
  title?: string;
  text?: string;
  price?: string;
  tag?: string;
}

export interface Setting {
  id?: number;
  site_name: string;
  language: string;
  timezone: string;
  dateformat: string;
  default_currency: string;
  default_tax_rate?: number | null;
  default_warehouse?: number | null;
  default_customer?: number | null;
  company_phone: string;
  company_email: string;
  company_address: string;
  logo?: string;
  products_prefix: string;
  supplier_prefix: string;
  purchase_prefix: string;
  purchaseReturn_prefix: string;
  sales_prefix: string;
  salesReturn_prefix: string;
  salesOrder_prefix: string;
  posinvoice_prefix: string;
  customer_prefix: string;
  expense_prefix: string;
  income_prefix: string;
  stockTransfer_prefix: string;
  stockAdjustment_prefix: string;
  estimation_prefix: string;
  transaction_prefix: string;
  employee_prefix: string;
  receipt_show_phone: boolean;
  receipt_show_address: boolean;
  receipt_show_email: boolean;
  receipt_show_customer: boolean;
  receipt_show_tax_discount: boolean;
  receipt_show_barcode: boolean;
  receipt_show_note_to_customer: boolean;
  receipt_note_to_customer: string;
  customer_display_posters: CustomerDisplayPoster[];
}

const settingService = {
  async getSettings(): Promise<Setting> {
    const response = await apiClient.get("/settings");
    return response.data.data;
  },

  async updateSettings(input: FormData | Partial<Setting>): Promise<Setting> {
    const headers =
      input instanceof FormData
        ? { "Content-Type": "multipart/form-data" }
        : undefined;
    const response = await apiClient.post("/settings", input, { headers });
    return response.data.data;
  },
};

export default settingService;
